import { lazy } from "react";
import type { RouteObject } from "react-router";

const MarketingIndex = lazy(() => import("./pages/page"));
const PostsPage = lazy(() => import("./pages/posts/page"));
const NewPostPage = lazy(() => import("./pages/posts/new/page"));
const PostDetailPage = lazy(() => import("./pages/posts/[id]/page"));
const PostEditPage = lazy(() => import("./pages/posts/[id]/edit/page"));
const SettingsPage = lazy(() => import("./pages/settings/page"));

export const marketingRoutes: RouteObject[] = [
  { index: true, Component: MarketingIndex },
  // Order matters: `posts/new` must precede `posts/:id` so the static
  // segment wins over the dynamic capture.
  { path: "posts", Component: PostsPage },
  { path: "posts/new", Component: NewPostPage },
  { path: "posts/:id", Component: PostDetailPage },
  { path: "posts/:id/edit", Component: PostEditPage },
  { path: "settings", Component: SettingsPage },
];
